import React from "react";
import ReactECharts from "echarts-for-react";

const BarChart = ({ data, title }) => {
    // Utility function to shorten X-axis names
    const shortenXAxisLabel = (value) => {
        const labelMap = {
            "ServiceOps Narrative": "SvcOps",
            "AIOps & Observability Narrative": "AIOps & Obs.",
            "One BMC Narrative - Mainframe & Distributed": "One BMC ",
            "End-to-End Observability Narrative with Live App": "E2E Obs.",
            "BMC Helix Platform Demo for Executives (CXO Dashboard Narrative)": "CXO Dash.",
            "Customer Service Management - CSM": "CSM",
            "Change Management DevOps meets ITIL": "Chg Mgmt",
            "Service Predictions": "Svc Pred.",
            "Security Incident Handling": "SIH",
            "Policy Based Clustering (Network Alerts)": "Policy Clustering",
            "The Complete Banking Story": "Complete Banking",
            "Agentic AI Driven HRSM": "HRSM",
            "HelixGPT - Vulnerability Resolver": "Vuln Ops"
        };
        return labelMap[value] || value; // Return shortened name if available, otherwise original
    };

    const xData = data?.map((item) => shortenXAxisLabel(item.Narrative)); // Shorten X-axis labels
    const yData = data?.map((item) => item.Count);

    const options = {
        grid: {
            left: "10%",
            right: "10%",
            top: "10%",
            bottom: "30%", // Adjust for long X-axis labels
        },
        tooltip: {
            trigger: "axis",
            backgroundColor: "#fff",
            borderColor: "#ccc",
            borderWidth: 1,
            borderRadius: 8,
            padding: [10, 15],
            textStyle: {
                color: "#333",
                fontSize: 14,
            },
        },
        xAxis: {
            type: "category",
            data: xData,
            axisLabel: {
                fontSize: 8,
                color: "#333",
                rotate: 0, // Rotate labels for better readability
                formatter: (value) => (value.length > 20 ? `${value.slice(0, 15)}...` : value), // Truncate long labels
            },
        },
        yAxis: {
            type: "value",
            axisLabel: {
                fontSize: 12,
                color: "#333",
            },
            splitLine: {
                lineStyle: {
                    type: "dashed",
                    color: "#E0E0E0",
                },
            },
        },
        dataZoom: [
            {
                type: "slider",
                xAxisIndex: 0,
                start: 0,
                zoomLock: true,
                moveOnMouseMove: false,
                showDetail: false,
                showDataShadow: true,
                realtime: true,
                brushSelect: false,
                end: 30, // Show the first 100% initially
                bottom: "10px", // Move the slider up to avoid overlapping
                handleSize: "100%", // Make the handle larger for better UX
                handleStyle: {
                    color: "#85D7FF", // Light blue handle color
                    borderWidth: 1,
                    borderColor: "#5AB1F6", // Slightly darker blue border
                },
                fillerColor: "rgba(133, 215, 255, 0.2)", // Transparent light blue background
                borderColor: "transparent", // Remove the border for a cleaner look
                textStyle: {
                    color: "transparent", // Hide text
                },
            },
        ],
        series: [
            {
                data: yData,
                type: "bar",
                itemStyle: {
                    color: "#85D7FF",
                },
                barWidth: "50%",
            },
        ],
    };

    return (
        <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px" }}>
            <h3 style={{ fontSize: "16px", color: "#333", marginBottom: "10px" }}>
                {title}
            </h3>
            <ReactECharts option={options} style={{ height: "400px", width: "100%" }} />
        </div>
    );
};

export default BarChart;
